import { Button } from "@mui/material";

const AddButton = ({ signers, deletedAfms, setAddDialogOpen }) => {
  const handleAddClick = () => {
    const totalSignersLength = signers.length - deletedAfms.length;

    if (totalSignersLength < 10) {
      setAddDialogOpen(true);
    } else {
      setNotification({
        open: true,
        color: "error",
        message: "Δεν επιτρέπεται η προσθήκη περισσότερων υπογραφόντων.",
      });
    }
  };

  return (
    <Button variant="contained" color="primary" onClick={handleAddClick}>
      Προσθήκη
    </Button>
  );
};
export default AddButton;
